import styled, { css } from "styled-components";
import { color, cssTemplate, media } from "../../../../constants/styles";
import { ReactComponent as JoinArrow } from "../../../../svgs/JoinArrow.svg";

export const cardDate = css`
  // font-family: "Fivo Sans Modern";
  // font-style: italic;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 120% */

  /* Primary/Neon Yellow Green 05 ⭐️ */

  color: #1e1e1e;
  ${media.MOBILE} {
    // font-family: "Fivo Sans Modern";
    // font-style: italic;
    font-weight: 500;
    font-size: 15px;
    line-height: 22px;
    /* identical to box height, or 114% */

    /* Primary/Neon Yellow Green 05 ⭐️ */

    color: #1e1e1e;
  }
`;
export const maxWidth = css`
  max-width: 1200px;
  ${media.TABLET} {
    max-width: 672px;
  }
  ${media.MOBILE} {
    max-width: 327px;
  }
`;
export const cardMain = css`
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  /* identical to box height, or 150% */

  /* Gray/Gray-08 (White) */

  color: #1e1e1e;
  // white-space: pre;
  ${media.MOBILE} {
    font-family: "Pretendard";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    /* identical to box height, or 133% */

    /* Gray/Gray-08 (White) */

    color: #1e1e1e;
  }
`;

export const cardSubTitle = css`
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: #1e1e1e;
`;
export const IntroWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 40px;
  width: 100%;
  ${maxWidth};
  ${(props) => cssTemplate.fadeInOut(props)}
  ${media.TABLET} {
    gap: 24px;
  }
  ${media.MOBILE} {
    // gap: 12px;
    max-width: 100%;
  }
`;

export const cardDesc = css`
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  /* Gray/Gray-05 */

  color: #1e1e1e;
  ${media.MOBILE} {
    font-family: "Pretendard";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    /* or 143% */

    /* Gray/Gray-05 */

    color: #1e1e1e;
  }
`;

export const Wrapper = styled.div`
  max-width: 1200px;
  // height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  // padding-left: calc((100vw - 1200px) / 2);

  ${media.TABLET} {
    // padding-left: calc(100vw / 10);
    // padding-right: 48px;
  }
  ${media.MOBILE} {
    align-items: center;
    // padding-left: 24px;
    // padding-right: 24px;
  }
`;
export const MiniTitle = styled.div`
  ${maxWidth}
  margin-bottom: 12px;
  // font-family: "Fivo Sans Modern";
  // font-style: italic;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;

  /* identical to box height, or 117% */

  /* Primary/Neon Yellow Green 05 ⭐️ */
  text-align: center;
  color: #84d500;
  ${media.TABLET} {
    // font-family: "Fivo Sans Modern";
    // font-style: italic;
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    /* identical to box height, or 117% */

    /* Primary/Neon Yellow Green 05 ⭐️ */

    color: #84d500;
    margin-bottom: 12px;
  }
  ${media.MOBILE} {
    // font-family: "Fivo Sans Modern";
    // font-style: italic;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    /* identical to box height, or 114% */

    /* Primary/Neon Yellow Green 05 ⭐️ */

    color: #84d500;
  }
  text-align: left;
  width: 100%;
`;
export const BigDesc = styled.div<{ color?: string }>`
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  font-size: 60px;
  line-height: 150%;
  /* or 90px */

  /* Gray/Gray-08 (White) */

  margin-bottom: 40px;
  color: ${({ color }) => color ?? "#1e1e1e"};
  ${media.TABLET} {
    font-family: "Pretendard";
    font-style: normal;
    font-weight: 700;
    font-size: 48px;
    line-height: 68px;
    /* or 142% */

    /* Gray/Gray-08 (White) */

    // color: #ffffff;
    text-align: left;
    width: 100%;
    margin-bottom: 24px;
  }
  ${media.MOBILE} {
    font-family: "Pretendard";
    font-style: normal;
    font-weight: 700;
    font-size: 26px;
    line-height: 38px;
    /* or 146% */
    width: 100%;
    text-align: left;
    width: 100%;

    /* Gray/Gray-08 (White) */

    // color: #ffffff;
  }
  ${maxWidth}
`;
export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  ${media.MOBILE} {
    // align-items: unset;
    // justify-content: unset;
  }
`;
export const StyledTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: 0px;
  gap: 12px;
  ${maxWidth}

  & > span {
    // font-family: "Fivo Sans Modern";
    // font-style: italic;
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    /* identical to box height, or 117% */

    /* Primary/Neon Yellow Green 05 ⭐️ */

    color: #90d700;
  }
  & > h1 {
    font-family: "Pretendard";
    font-style: normal;
    font-weight: 700;
    font-size: 60px;
    line-height: 150%;
    /* or 90px */

    /* Gray/Gray-08 (White) */

    color: #1e1e1e;
  }

  & > span.black-title {
    color: #b3ff01;
  }

  & > h1.black-title {
    color: #fff;
  }
  ${media.TABLET} {
    & > h1 {
      font-size: 48px;
      line-height: 68px;
    }
    & > span {
      font-size: 24px;
      line-height: 28px;
    }
  }
  ${media.MOBILE} {
    max-width: 100%;
    & > h1 {
      font-size: 26px;
      line-height: 38px;
    }
    & > span {
      font-size: 14px;
      line-height: 16px;
    }
  }
`;

export const SmallDesc = styled.div`
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  /* or 150% */

  /* Gray/Gray-05 */

  color: #646464;
  ${media.TABLET} {
    font-family: "Pretendard";
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 30px;
    /* or 150% */

    /* Gray/Gray-05 */

    color: #646464;
  }
  ${media.MOBILE} {
    font-family: "Pretendard";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;

    word-break: keep-all;
    /* or 150% */

    /* Gray/Gray-05 */

    color: #646464;
  }
`;
export const Title = styled.div`
  color: #ffffff;
  margin-bottom: 160px;
  word-break: keep-all;
  h2 {
    font-style: normal;
    font-weight: 700;
    font-size: 100px;
    line-height: 140px;
  }

  h3 {
    font-weight: 700;
    font-size: ${cssTemplate.vwConvertPc(88)};
    line-height: 1.5;
  }

  strong {
    color: ${color.GREEN};
  }

  ${media.TABLET} {
    h2 {
      font-family: "Pretendard";
      font-style: normal;
      font-weight: 700;
      font-size: 60px;
      line-height: 150%;
    }
  }

  ${media.MOBILE} {
    h2 {
      font-size: 40px;
      line-height: 44px;
    }
  }
`;

export const ArrowIcon = styled(JoinArrow)`
  stroke: #646464;
  fill: #646464;
  &:hover {
    stroke: #ffffff;
    fill: #ffffff;
  }
  transition: all 0.3s;
  ${media.TABLET} {
    stroke: #ffffff;
    fill: #ffffff;
  }
  ${media.MOBILE} {
    stroke: #ffffff;
    fill: #ffffff;
  }
`;
